export default __webpack_public_path__ + "static/0266-95cba7eabdee0125bd907ed938fad22e.png";